import classNames from 'clsx'
import { bool } from 'prop-types'

import Price from 'views/components/atoms/Price'

import './PriceOld.scss'

const PriceOld = ({
  amount,
  currency,
  symbolRight,
  inheritColor,
  noLineThrough,
}) => {
  const classname = classNames('a-PriceOld', {
    'a-PriceOld--color-inherit': inheritColor,
  })
  const classNamePrice = classNames('a-PriceOld--price', {
    'a-PriceOld--no-line-through': noLineThrough,
  })

  return (
    <span className={classname}>
      <span className={classNamePrice}>
        <Price
          amount={amount}
          currency={currency}
          symbolRight={symbolRight}
          dataQa="product-old-price"
        />
      </span>
    </span>
  )
}

PriceOld.propTypes = {
  ...Price.propTypes,
  inheritColor: bool,
  noLineThrough: bool,
}

PriceOld.defaultProps = {
  ...Price.defaultProps,
  inheritColor: false,
  noLineThrough: false,
}

export default PriceOld
